import React, { useEffect, useState } from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { isLoggedIn } from '../../services/auth';
import AdminLayout from '../../components/layout/AdminLayout';

const PrivateRoute = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const checkAuthentication = async () => {
      const authenticated = await isLoggedIn();
      setIsAuthenticated(authenticated);
    };

    checkAuthentication();
  }, []);

  if (isAuthenticated === false) {
    return <Navigate to="/ava-admin/callback" />;
  }

  const currentPage = location.pathname.split('/').pop();

  return (
  <AdminLayout page={currentPage}>
      {isAuthenticated === null ? (
      <div className="flex justify-center items-center h-screen">
        <div className="w-12 h-12 border border-8 border-gray-300 border-t-orange-500 rounded-full animate-spin" />
      </div>
      ) : (
        <Outlet />
      )}
    </AdminLayout>
  );
};

export default PrivateRoute;
